var React = require('react');

function DotbLogoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.29,38.82,47.23,15.5l37.9,23.32H78.22l-31-17.13-31,17.13ZM47.23,24.71l25.32,14V62H67.94V41H49.53V62H45l-.07-21H26.51V62H21.9V38.69ZM21.9,64.34H72.55l4.6,2.33H17.3ZM15,69H79.45l4.61,2.33H10.39ZM8.09,73.66H86.36L91,76H3.49Zm-4.6,0v-7h4.6v4.66Zm87.47,0-4.6-2.33V66.77H91Zm-3.81-9.31a44.4,44.4,0,0,0,3.47-17.26c0-24.25-19.41-43.91-43.36-43.91S3.9,22.84,3.9,47.09A44.31,44.31,0,0,0,7.37,64.34H4A47.49,47.49,0,0,1,.76,47.09C.76,21.08,21.58,0,47.26,0s46.5,21.08,46.5,47.09a47.43,47.43,0,0,1-3.22,17.25Z","transform":"translate(-0.76 0)","fillRule":"evenodd"}));
}

DotbLogoInline.defaultProps = {"viewBox":"0 0 93 75.99"};

module.exports = DotbLogoInline;

DotbLogoInline.default = DotbLogoInline;
